var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#E8EEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.06 28.3472V44.8M32.06 28.3472L37.4381 33.8314M32.06 28.3472L26.6819 33.8314M41.9198 37.4876C44.6429 37.4876 46.4016 35.2372 46.4016 32.4604C46.4015 31.361 46.048 30.292 45.3952 29.417C44.7425 28.542 43.8265 27.9094 42.7875 27.616C42.6276 25.5657 41.7944 23.6303 40.4224 22.1227C39.0504 20.6152 37.2199 19.6235 35.2268 19.3081C33.2337 18.9927 31.1946 19.3719 29.4391 20.3846C27.6835 21.3972 26.3142 22.984 25.5525 24.8884C23.9488 24.4351 22.2342 24.65 20.7859 25.4858C19.3376 26.3217 18.2741 27.71 17.8296 29.3453C17.385 30.9807 17.5958 32.7291 18.4154 34.2061C19.2351 35.683 20.5965 36.7674 22.2002 37.2207",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileLogo);
export default __webpack_public_path__ + "static/media/uploadFileLogo.c262cbac2fd63b79c348b68f31ecf649.svg";
export { ForwardRef as ReactComponent };